export const REQUEST_GIFT_PURCHASE = 'REQUEST_PURCHASE_GIFT'
export const requestPurchase = () => ({ type: REQUEST_GIFT_PURCHASE })

export const RECEIVE_GIFT_PURCHASE = 'RECEIVE_PURCHASE_GIFT'
export const receivePurchase = giftId => ({ type: RECEIVE_GIFT_PURCHASE, giftId })

export const GIVE_A_GIFT = 'GIVE_A_GIFT'
export const giveGift = giftId => ({ type: GIVE_A_GIFT, giftId })

export const MONETIZE_GIFT = 'MONETIZE_GIFT'
export const monetizeGift = giftId => ({ type: MONETIZE_GIFT, giftId })

export const giftTypes = {
  bought: 'Bought',
  received: 'Received'
}

// delay until notification is removed
const NOTIFICATION_TIME = 2000

// hide notification in shop that the gift was purchased
export const HIDE_GIFT_NOTIFCATION = 'HIDE_GIFT_NOTIFCATION'
const hideGiftNotification = () => ({ type: HIDE_GIFT_NOTIFCATION })

// action for purchasing a new gift
export const purchaseGift = (personId, giftId) => dispatch => {
  dispatch(requestPurchase())

  return fetch(process.env.REACT_APP_BASE_URL + '/gifts/buy_gift',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId, giftId })
    }
  ).then(() => {
    dispatch(receivePurchase(giftId)) // will also show the "Purchased" notification
    setTimeout(() => dispatch(hideGiftNotification()), NOTIFICATION_TIME) // and then remove it
  })
}

export const fetchMonetizeGift = (personId, giftId) => dispatch => {
  return fetch(process.env.REACT_APP_BASE_URL + '/gifts/monetize_gift',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId, giftId })
    }
  ).then(() => {
    dispatch(monetizeGift(giftId))
  })
}

export const fetchGiveGift = (ownerId, receiverId, giftId) => dispatch => {

  return fetch(process.env.REACT_APP_BASE_URL + '/gifts/give_gift',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ ownerId, receiverId, giftId })
    }
  ).then(() => dispatch(giveGift(giftId)))
}

export const REQUEST_PURCHASED_GIFTS = 'REQUEST_PURCHASED_GIFTS'
const requestGifts = () => ({ type: REQUEST_PURCHASED_GIFTS })

export const RECEIVE_PURCHASED_GIFTS = 'RECEIVE_PURCHASED_GIFTS'
const receiveGifts = (gifts) => ({
  type: RECEIVE_PURCHASED_GIFTS,
  gifts
})

// action for fetching data about purchased gifts from API
export const fetchPurchasedGifts = personId => dispatch => {
  dispatch(requestGifts())

  return fetch(process.env.REACT_APP_BASE_URL + '/gifts/get_gifts',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId })
    })
    .then(
      response => response.json(),
      error => console.error(error)
    )
    .then(json => dispatch(receiveGifts(json)))
}
